/*
  Laurent: "Passt dazu" im Warenkorb (Spec 46).

  Holt die Empfehlungen zum ersten Artikel im Korb und setzt sie in die
  Sektion. Die fertige Adresse steht in data-lh-passt, gebaut in Liquid —
  hier wird nichts zusammengesetzt.

  Nicht ueber Crafts <product-recommendations> aus global.js: das haengt am
  IntersectionObserver, und die leere Sektion hat keine Hoehe. Gemessen
  (14.08.) lud sie beim Sprung ans Seitenende gar nicht nach — eine Linie
  ohne Hoehe schneidet den Sichtbereich nicht, wenn der Sprung sie
  ueberspringt. Auf der Warenkorbseite ist ein Ruf sofort billiger als eine
  Reihe, die manchmal fehlt.

  Faellt der Ruf aus, bleibt die Sektion leer und die Seite ohne Luecke —
  die senkrechten Abstaende haengen am Inhalt, nicht am Rahmen.
*/

(function () {
  var kasten = document.querySelector('[data-lh-passt]');
  if (!kasten) return;

  var adresse = kasten.getAttribute('data-lh-passt');
  if (!adresse) return;

  fetch(adresse)
    .then(function (antwort) {
      return antwort.text();
    })
    .then(function (text) {
      var raum = document.createElement('div');
      raum.innerHTML = text;

      var frisch = raum.querySelector('[data-lh-passt]');
      if (frisch && frisch.innerHTML.trim().length) {
        kasten.innerHTML = frisch.innerHTML;
      }
    })
    .catch(function () {
      /* Ohne Empfehlung bleibt die Reihe weg. Die Seite steht trotzdem. */
    });
})();
